import { SHOOTS_FETCH_REQUEST, SHOOTS_FETCH_SUCCESS, SHOOTS_FETCH_FAILURE } from './types';
import baseUrl from '../url'

const fetchShootRequest = () => {
    return {
        type: SHOOTS_FETCH_REQUEST
    }
}

const fetchShootSuccess = shoots => {
    return {
        type: SHOOTS_FETCH_SUCCESS,
        payload: shoots,
    }
}

const fetchShootFailure = error => {
    return {
        type: SHOOTS_FETCH_FAILURE,
        payload: error,
    }
}

export const getShoots = slug => {
    if (slug) {
        return (dispatch) => {
            dispatch(fetchShootRequest());
            fetch(`${baseUrl}/shoot_types/${slug}`, {
                    method: 'GET'
                })
                .then(response => response.json())
                .then((response) => {
                    let res = response.sort((a, b) => {
                        if (a.order < b.order) { return -1; }
                        if (a.order > b.order) { return 1; }
                        return 0;
                    });
                    dispatch(fetchShootSuccess(res))
                })
                .catch((error) => {
                    dispatch(fetchShootFailure(error.message));
                })
        }
    } else {
        return (dispatch) => { dispatch(fetchShootSuccess({})); }
    }
}